import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BusinessCatalogItem } from '@/lib/api/types/businessCatalog';

interface CatalogState {
  items: BusinessCatalogItem[];
  loading: boolean;
  error: string | null;
}

const initialState: CatalogState = {
  items: [],
  loading: false,
  error: null,
};

const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    fetchCatalogRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCatalogSuccess: (
      state,
      action: PayloadAction<BusinessCatalogItem[]>
    ) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchCatalogFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCatalog: (state) => {
      state.items = [];
    },
  },
});

export const {
  fetchCatalogRequest,
  fetchCatalogSuccess,
  fetchCatalogFailure,
  clearCatalog,
} = catalogSlice.actions;

export default catalogSlice.reducer;
